'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Cat = _react2['default'].createClass({
  displayName: 'Cat',

  PropTypes: {
    options1: _react2['default'].PropTypes.array.isRequired,
    options2: _react2['default'].PropTypes.array.isRequired,
    handleCat: _react2['default'].PropTypes.func.isRequired,
    handleSubcat: _react2['default'].PropTypes.func.isRequired,
    name: _react2['default'].PropTypes.string.isRequired
  },
  handleClick1: function handleClick1(e) {
    e.preventDefault();
    this.props.handleCat(e.target.value);
  },
  handleClick2: function handleClick2(e) {
    e.preventDefault();
    this.props.handleSubcat(e.target.value);
  },
  render: function render() {

    var show = this.props.options2 === null ? { display: 'none' } : { display: 'inline' };
    var options1 = undefined,
        options2 = undefined;

    options1 = this.props.options1.map(function (d, i) {
      return _react2['default'].createElement(
        'option',
        { key: 'cat' + i, value: d },
        d
      );
    });

    options2 = this.props.options2 === null ? null : this.props.options2.map(function (d, i) {
      return _react2['default'].createElement(
        'option',
        { key: 'subcat' + i, value: d },
        d
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: 'choose' },
      _react2['default'].createElement(
        'span',
        null,
        ' In ',
        this.props.name,
        ' '
      ),
      _react2['default'].createElement(
        'select',
        { id: 'catMenu1', onChange: this.handleClick1 },
        options1
      ),
      _react2['default'].createElement(
        'span',
        { style: show },
        ' Subcategory '
      ),
      _react2['default'].createElement(
        'select',
        { style: show, id: 'catMenu2', onChange: this.handleClick2 },
        options2
      )
    );
  }
});
exports.Cat = Cat;
//# sourceMappingURL=data:application/json;base64,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